import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTransactions } from '../../api/subscription';
import { selectAdminAuth } from './adminAuthSlice';

const initialState = {
  transactions: [],
  meta: {},
  filters: {
    email: '',
    status: '',
    source: '',
    min_amount: '',
    max_amount: '',
    start_date: '',
    end_date: '',
  },
  page: 0,
  loading: false,
  error: '',
};

export const fetchTransactionsThunk = createAsyncThunk(
  'transaction/fetchTransactions',
  async ({ filters, page }, thunkApi) => {
    try {
      const state = thunkApi.getState();
      const { token } = state.adminAuth;
      const ITEMS_PER_PAGE = 20;
      const data = await fetchTransactions(token, { ...filters, limit: ITEMS_PER_PAGE, offset: page * ITEMS_PER_PAGE });
      return { transactions: data.transactions || [], meta: data.meta || {}, filters, page };
    } catch (err) {
      return thunkApi.rejectWithValue(err.response?.data?.error || err.message || 'Failed to fetch transactions');
    }
  }
);

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    clearTransactions: (state) => {
      state.transactions = [];
      state.meta = {};
      state.filters = initialState.filters;
      state.page = 0;
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactionsThunk.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchTransactionsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload.transactions;
        state.meta = action.payload.meta;
        state.filters = action.payload.filters;
        state.page = action.payload.page;
        state.error = '';
      })
      .addCase(fetchTransactionsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilters, setPage, clearTransactions } = transactionSlice.actions;
export const selectTransactions = (state) => state.transaction.transactions;
export const selectTransactionMeta = (state) => state.transaction.meta;
export const selectTransactionFilters = (state) => state.transaction.filters;
export const selectTransactionPage = (state) => state.transaction.page;
export const selectTransactionLoading = (state) => state.transaction.loading;
export const selectTransactionError = (state) => state.transaction.error;

export default transactionSlice.reducer; 